import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiDelete } from '@/lib/http/client';
import {
  portfolioMemberTeamUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';

interface RemoveTeamParams {
  userId: number;
  teamEntityId: string;
}

export function useRemoveTeam(portfolioId: number, orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, teamEntityId }: RemoveTeamParams) =>
      apiDelete(
        portfolioMemberTeamUrl(portfolioId, orgId, userId, teamEntityId)
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgMembers(portfolioId, orgId),
      });
    },
  });
}
